import { useState } from "react";
import { useEffect } from "react";
import { Card, CardContent } from "../components/ui/Card";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import LeftSidebar from "../components/LeftSidebar";
import {
  BadgeDollarSign,
  ChartPie,
  CalendarDays,
  Calendar1,
  TrendingUp,
  TriangleAlert,
  TrendingDown,
} from "lucide-react";
import Reset from "./Reset";
import Chart from "../components/Chart";
import loginImage from "../assets/img/Login.png";


const salesData = [
  { name: "Jul", sales: 4000 },
  { name: "Aug", sales: 4500 },
  { name: "Sep", sales: 4800 },
  { name: "Oct", sales: 6200 },
  { name: "Nov", sales: 7000 },
  { name: "Dec", sales: 8000 },
  { name: "Jan", sales: 7500 },
  { name: "Feb", sales: 7200 },
  { name: "Mar", sales: 7600 },
  { name: "Apr", sales: 8000 },
];


const Dashboard = () => {
  const [showResetPopup, setShowResetPopup] = useState(false);

  useEffect(() => {
    // Check if reset popup has already been shown
    // const resetPopupShown = localStorage.getItem("resetPopupShown");
    // if (!resetPopupShown) {
    //   setShowResetPopup(true);
    // }
  }, []);

  const handleCloseReset = () => {
    setShowResetPopup(false);
    localStorage.setItem("resetPopupShown", "true"); // Store in localStorage
  };
  return (
    <div className="flex text-textColor  bg-customGray font-sans min-h-screen">
      {showResetPopup && <Reset onClose={handleCloseReset} />}
      {/* Dim the dashboard when Reset popup is shown */}
      <div
        className={`${
          showResetPopup ? "opacity-60 pointer-events-none" : ""
        } flex w-full`}
      >

        <div className="flex flex-col flex-1 w-4/5  p-1">
          {/* Top Row: 4 Cards */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-6 gap-2 mb-[2px] ml-2 mr-2 md:ml-0 md:mr-0 font-sans   bg-white w-full py-2 px-1 rounded-lg">
            <Card className="bg-[#EEF1FF] hover:bg-[#e5e9fb] h-[64px] p-2 rounded-md">
              <CardContent>
                <p className="text-sm text-textColor font-medium flex justify-between">
                  PENDING <TriangleAlert size={15} />
                </p>
                <div className="flex justify-between">
                  <h2 className="text-base font-bold text-gray-900 mb-1">14</h2>
                </div>
              </CardContent>
            </Card>
            <Card className="bg-[#FBD89F] hover:bg-[#f3cd7b] h-[64px] p-2 rounded-md">
              <CardContent>
                <p className="text-sm text-textColor font-medium flex justify-between">
                  JANUARY LEADS<Calendar1 size={15} />
                </p>
                <div className="flex justify-between">
                  <h2 className="text-base font-bold text-gray-900 mb-1">
                    30
                  </h2>
                  <p className="text-xs text-textColor font-semibold flex items-center gap-1">
                    <TrendingUp size={15} /> 5% +
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-[#C2EAE7] h-[64px] p-2 hover:bg-[#8cf3ec] rounded-md">
              <CardContent>
                <p className="text-sm text-textColor font-medium flex justify-between">
                  THIS YEAR LEADS<CalendarDays size={15} />
                </p>
                <div className="flex justify-between">
                  <h2 className="text-base font-bold text-gray-900 mb-1">
                    435
                  </h2>
                  <p className="text-xs text-textColor font-semibold flex items-center gap-1">
                    <TrendingUp size={15} />
                    16% +
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-[#FFC3C4] h-[64px] p-2 hover:bg-[#eca5a6] rounded-md">
              <CardContent>
                <p className="text-sm text-textColor font-medium flex justify-between">
                  COLD LEADS <ChartPie size={15} />
                </p>
                <div className="flex justify-between">
                  <h2 className="text-base font-bold text-gray-900 mb-1">
                    24
                  </h2>
                  <p className="text-xs text-textColor font-semibold flex items-center gap-1">
                    <TrendingDown size={15} /> 5% +
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-r from-red-500 via  to bg-orange-500 hover:from-red-600 via to hover:bg-orange-600 h-[64px] p-2  rounded-md">
              <CardContent>
                <p className="text-sm text-white font-medium flex justify-between">
                  TOTAL LEADS <BadgeDollarSign size={15} color="#fdfdfd" />
                </p>
                <div className="flex justify-between">
                  <h2 className="text-base font-bold text-white mb-2">
                    1743
                  </h2>
                  <p className="text-xs font-semibold flex items-center gap-1 text-white">
                    <TrendingUp size={15} color="#ffffff" /> 5% +
                  </p>
                </div>
              </CardContent>
            </Card>
            <Card className="bg-white hover:bg-[#e5e9fb] h-[64px] p-2 rounded-md">
              <CardContent className="">
                <p className="text-sm text-customOrange font-medium flex gap-4 items-center">
                  {" Amandeep singh"}
                  <button className="hover:bg-gray-100 p-2 rounded-full">
                <svg
                  className="h-5 w-5 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z"
                  />
                </svg>
              </button>
                </p>
              </CardContent>
            </Card>
          </div>

          <div className="flex">
          <div className="p-2 md:p-4 lg:p-6">
          {/* Second Row: Graph and Chart */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <Card className="bg-white border border-gray-200 hover:border-blue-100 hover:bg-transparent p-1 lg:p-4 shadow-md rounded-lg">
              <CardContent>
                <h2 className="text-base font-medium lg:text-center lg:font-bold text-textColor mb-3">
                  Ship Summary
                </h2>
                <table className="w-full border-collapse border  border-gray-100">
                  <thead>
                    <tr className="bg-gray-100 text-start lg:text-center">
                      <th className="border border-gray-200 p-2 text-start lg:text-center">Report</th>
                      <th className="border border-gray-200 p-2 text-start lg:text-center">
                        All Trips
                      </th>
                      <th className="border border-gray-200 p-2 text-start lg:text-center">
                        My Trips
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border border-gray-100 text-start lg:text-center">
                      <th className="border border-white p-2 bg-red-100 text-start lg:text-center">
                        Not Covered
                      </th>
                      <td className="border border-gray-100 p-2 text-start lg:text-center">
                        13
                      </td>
                      <td className="border border-gray-100 p-2 text-start lg:text-center">
                        7
                      </td>
                    </tr>
                    <tr className="border border-white text-start lg:text-center">
                      <th className="border border-white p-2 bg-orange-100 text-start lg:text-center">
                        Covered & Dispatched
                      </th>
                      <td className="border border-gray-100 p-2 text-start lg:text-center">
                        64
                      </td>
                      <td className="border border-gray-200 p-2 text-start lg:text-center">
                        84
                      </td>
                      </tr>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 bg-blue-100 text-start lg:text-center">
                          In Transit
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          2
                        </td>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          0
                        </td>
                      </tr>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 bg-green-100 text-start lg:text-center">
                          Delivered
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          103
                        </td>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          97
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CardContent>
              </Card>
              <Card className="bg-white border border-gray-200 hover:border-blue-100 hover:bg-transparent p-1 lg:p-4 shadow-md rounded-lg">
                <CardContent>
                  <h2 className="text-base font-medium lg:text-lg lg:font-bold text-textColor mb-3 text-start lg:text-center">
                    Requires Attention
                  </h2>
                  <table className="w-full border-collapse border border-gray-200">
                    <thead>
                      <tr className="bg-gray-100 text-start lg:text-center">
                        <th className="border border-gray-200 p-2 text-start lg:text-center">Report</th>
                        <th className="border border-gray-200 p-2 text-start lg:text-center">
                          All Trips
                        </th>
                        <th className="border border-gray-200 p-2 text-start lg:text-center">
                        My Trips
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border border-gray-200 text-start lg:text-center">
                        <th className="border border-white p-2 bg-blue-100 text-start lg:text-center">
                          Caution
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          13
                        </td>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          7
                        </td>
                      </tr>
                      <tr className="border border-white text-start lg:text-centerr">
                        <th className="border border-white p-2 bg-green-100 text-start lg:text-center">
                          Important
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          12
                        </td>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          7
                        </td>
                      </tr>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 text-start lg:text-center bg-red-100">
                          Critical
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          5
                        </td>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          1
                        </td>
                      </tr>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 bg-orange-100 text-start lg:text-center">
                          Running Late
                        </th>

<td className="border border-gray-200 p-2 text-start lg:text-center">
                          4
                        </td>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          0
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CardContent>
              </Card>
            </div>
            {/* Third Row: Unassigned Assets and Safety Summary */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <Card className="bg-white border border-gray-200 hover:border-blue-100 hover:bg-transparent p-1 lg:p-4 shadow-md rounded-lg">
                <CardContent>
                  <h2 className="text-base font-medium lg:text-lg lg:font-bold text-textColor mb-3 text-start lg:text-center">
                    Unassigned Assets
                  </h2>
                  <table className="w-full border-collapse border border-gray-300">
                    <thead>
                      <tr className="bg-gray-100 text-start lg:text-center">
                        <th className="border border-gray-200 p-2 text-start lg:text-center">Report</th>
                        <th className="border border-gray-200 p-2 text-start lg:text-center">
                          Asset
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 bg-purple-100 text-start lg:text-center">
                          Unassigned Trucks
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          13
                        </td>
                      </tr>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 bg-cyan-100 text-start lg:text-center">
                          Unassigned Trailers
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          7
                        </td>
                      </tr>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 bg-lime-100 text-start lg:text-center">
                          Unassigned Drivers
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          13
                        </td>
                      </tr>
                    </tbody>
                    </table>
                </CardContent>
              </Card>
              <Card className="bg-white border border-gray-200 hover:border-blue-100 hover:bg-transparent p-1 lg:p-4 shadow-md rounded-lg">
                <CardContent>
                  <h2 className="text-base font-medium lg:text-lg lg:font-bold text-textColor mb-3 text-start lg:text-center">
                    Safety Summary
                  </h2>
                  <table className="w-full border-collapse border border-gray-300 text-start lg:text-center">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border border-gray-200 p-2 text-start lg:text-center">Asset</th>
                        <th className="border border-gray-200 p-2 text-start lg:text-center">
                          Expired
                        </th>
                        <th className="border border-gray-200 p-2 text-start lg:text-center">
                          Expiring Soon
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 bg-purple-100 text-start lg:text-center">
                          Trucks
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          1
                        </td>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          0
                        </td>
                      </tr>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 bg-cyan-100 text-start lg:text-center">
                          Trailers
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          0
                        </td>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          0
                        </td>
                      </tr>
                      <tr className="border border-white text-start lg:text-center">
                        <th className="border border-white p-2 bg-lime-100 text-start lg:text-center">
                          Drivers
                        </th>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          0
                        </td>
                        <td className="border border-gray-200 p-2 text-start lg:text-center">
                          1
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CardContent>
              </Card>
            </div>
          </div>

            <div className="flex flex-col  mb-6">
              {/* Calendar Section */}
              <Card className="bg-white border border-gray-200 hover:border-blue-100 hover:bg-transparent p-1 lg:p-4 mb-1 w-full ">
                <CardContent className="w-full">
                  <Chart />
                </CardContent>
              </Card>
              {/* Calendar Section */}
              <Card className="bg-greenBg text-white border border-gray-200 hover:border-blue-100 p-2 sm:p-4 mb-1">
                <h1>TOTAL LOADS</h1>
                <div className="flex justify-around">
                  <ul className="mr-1 border-gray-500 px-4">
                    <li>64</li>
                    <li>This month</li>
                  </ul>
                  <ul>
                    <li>798</li>
                    <li>Year 2024</li>
                  </ul>
                  <ul className="border-l-2 border-gray-500 ml-1 px-5">
                    <li>678</li>
                    <li>Year 2023</li>
                  </ul>
                  <ul>
                    <li>567</li>
                    <li>Year 2023</li>
                  </ul>
                </div>
              </Card>
            </div>
          </div>

          {/* third section: Graph and card */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6 ml-2 mr-2 md:ml-4 md:mr-4">
            <Card className="lg:col-span-2 bg-white border border-gray-200 hover:border-blue-100 hover:bg-transparent p-6">
              <CardContent>
                <h2 className="text-base font-medium lg:text-lg lg:font-bold  text-textColor mb-3">
                  Sales Overview
                </h2>
                <ResponsiveContainer width="100%" height={250}>
                  <LineChart data={salesData}>
                    <XAxis dataKey="name" stroke="#ccc" />
                    <YAxis stroke="#ccc" />
                    <Tooltip wrapperStyle={{ backgroundColor: "#333" }} />
                    <Line
                      type="monotone"
                      dataKey="sales"
                      stroke="#8884d8"
                      strokeWidth={2}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
            <div
              style={{
                backgroundImage: `linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url(${loginImage})`,
              }}
              className=" bg-cover bg-center border  border-gray-200 hover:border-blue-100 hover:bg-transparent rounded-3xl p-6 "
            >
              <Card>
                <CardContent>
                  <h2 className="text-base font-medium lg:text-lg lg:font-bold text-blue-600 mb-3 overflow-x-hidden ">
                    Most Popular and Trusted
                  </h2>
                  <button className="bg-customOrange hover:bg-[#259999] p-1 px-4 rounded-lg overflow-hidden shadow font-semibold text-white ">
                    learn more
                  </button>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>

      {/* Reset Password Popup */}
      {showResetPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <Reset onClose={() => setShowResetPopup(false)} />
        </div>
      )}
      <div className="sticky top-0 h-screen">
        <LeftSidebar />
      </div>
    </div>
  );
};

export default Dashboard;
